import { ICustomerRole } from "../../models/auth/CustomerRole";
import { DASHBOARD_ROLE_CLAIM, IWilmaUser } from "../../models/auth/WilmaUser";

// Users whose access was hand-edited in core, or who were never given a role
export const CUSTOM_ROLE = "custom";

// Option values are lower-cased so they match the claim whatever casing Betty stored it in
export const roleValue = (role: ICustomerRole) => role.id.toLowerCase();

export const userRoleValue = (user: IWilmaUser) =>
    user.userClaims?.filter((c) => c.type === DASHBOARD_ROLE_CLAIM).pop()?.value?.toLowerCase() ?? CUSTOM_ROLE;

export const defaultRoleValue = (roles: ICustomerRole[]) => {
    const staff = roles.find((r) => r.name.trim().toLowerCase() === "staff");
    return staff ? roleValue(staff) : "";
};

export default function RoleSelect({ roles, value, onChange, disabled = false, showCustom = false, hint }: {
    roles: ICustomerRole[],
    value: string,
    onChange: (value: string) => void,
    disabled?: boolean,
    showCustom?: boolean,
    hint?: string,
}) {
    return (
        <div className="sm:col-span-1">
            <label className="text-sm font-medium text-gray-500">
                Role
            </label>
            <select
                aria-label="Role"
                value={value}
                disabled={disabled}
                onChange={(e) => onChange(e.target.value)}
                className="w-full mt-1 text-sm text-gray-900 h-[40px] disabled:bg-gray-300"
            >
                {value === "" && <option value="" disabled>Select a role</option>}
                {roles.map((role) => (
                    <option key={role.id} value={roleValue(role)}>
                        {role.name}
                    </option>
                ))}
                {showCustom && <option value={CUSTOM_ROLE}>Custom</option>}
            </select>
            {hint && <p className="mt-1 text-xs text-gray-400">{hint}</p>}
        </div>
    )
}
